import axios from 'axios';

const API = axios.create({
    baseURL: '/', // Исправлено: теперь Nginx сам добавит /api там, где нужно
    withCredentials: true,
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token') || localStorage.getItem('access');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    if (document.cookie) {
        const csrfCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('csrftoken='));
        
        if (csrfCookie) {
            config.headers['X-CSRFToken'] = csrfCookie.split('=')[1];
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// ГЛОБАЛЬНАЯ БРОНЯ ОТ КРАШЕЙ
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Если сервер вообще не ответил (обрыв связи, CORS, 502)
    if (!error.response) {
        // Создаем фейковый ответ, чтобы React не падал при чтении .data
        error.response = {
            data: { detail: "Сервер недоступен или запрос заблокирован." },
            status: 500
        };
        console.error("[Axios] Критическая ошибка сети:", error);
    } else if (error.response.status === 401) {
        console.error("[Axios] Ошибка 401: Токен истек.");
    }
    return Promise.reject(error);
  }
);

export default API;